import { ConfirmationDialogueComponent } from '@/app/components/global/dialog-boxes/confirmation-dialogue/confirmation-dialogue.component';
import { FilterToolComponent } from '@/app/components/global/filter-tool/filter-tool.component';
import { ModalConfigratoinData } from '@/app/components/global/modal-configration-data.json';
import { WrapperComponent } from '@/app/components/projects/wrapper/wrapper.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '../../rfp-labels.service';

interface IttItem {
  id: number;
  code: string;
  title: string;
  total: number;
  total_pending: number;
  total_submitted: number;
  total_queries: number;
  total_addendums: number;
  reference_number: string;
}

@Component({
  selector: 'app-itt-listing',
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    WrapperComponent,
    FilterToolComponent,
    MatMenuModule,
  ],
  templateUrl: './itt-listing.component.html',
  styleUrl: './itt-listing.component.css',
})
export class IttListingComponent implements OnInit {
  isCreate = false;
  currentDialog = 'itt-wrapper';
  activeRowIndex: number | null = null;
  ITT_confirmation_dialog_data =
    ModalConfigratoinData.ITT_Confirmation_Dialog_Data;
  tableData: IttItem[] = [];
  isEdit: boolean = false;

  projectId: number;
  projectName: string;
  projectIdentifier: string;
  labels: any;
  isRFPorRFQ: string;

  constructor(
    private dialog: MatDialog,
    private TenderingService: TenderingService,
    private router: Router,
    private route: ActivatedRoute,
    private rfpLabelService: RfpLabelService
  ) {}

  ngOnInit(): void {
    this.route.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    console.log('label service subscribe callback going to be invoked');
    this.rfpLabelService.labels$.subscribe((labels) => {
      console.log('label service subscribe callback invoked');
      this.labels = labels;
      console.log('this.labels:', this.labels);
    });
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
    });

    if (this.projectId) {
      this.getIttDeveloperListing(this.isRFPorRFQ);
    }
  }

  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }

  /**
   * NOTE: this function is called when we close the model
   *  event is emitted from the wrapper component and is reached here.
   *
   * IMP: we need to reset values here as if we dont, then the dialogue
   *  will not open as the values will not change and if the values wont
   *  change, we can not trigger the wrapper after once we open it
   */
  handleITTDialogClose() {
    this.isCreate = false;
    this.isEdit = false;
    this.getIttDeveloperListing(this.isRFPorRFQ);
  }

  // NOTE: this is called when we click on create itt
  handleCreateItt() {
    this.isCreate = true;
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
  }

  // NOTE: this is called when we click edit an itt
  handleEdit(id: number) {
    this.TenderingService.setIttId(id);
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
    this.isEdit = true;
  }

  confirmationDialog() {
    // Opens the dialog
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '30.313rem',
      height: '15.75rem',
      autoFocus: false,
      data: {
        ...this.ITT_confirmation_dialog_data,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.activeRowIndex = null; // Reset activeRowIndex to null
    });
  }

  getIttDeveloperListing(isRFPorRFQ: string) {
    // TODO: FIX IT
    return this.TenderingService.getIttDeveloperListing(
      this.projectId, isRFPorRFQ
    ).subscribe({
      next: (response) => {
        this.tableData = response?.data as IttItem[]; // Cast response to match the type
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  navigateToView(id: number) {
    this.TenderingService.setIttId(id);
    if(this.isRFPorRFQ === 'RFP'){
      this.router.navigate(['/initiate/rfp', this.projectId, id], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }else if(this.isRFPorRFQ === 'RFQ'){
      this.router.navigate(['/initiate/rfq', this.projectId, id], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }
  }

  navigateToClarification(rfpId: number, tab: string) {
    this.TenderingService.setIttId(rfpId);
    if(this.isRFPorRFQ === 'RFP'){
      this.router.navigate([`projects/${this.projectId}/rfp/${rfpId}/clarifications`], {
        queryParams: {
          tab: tab,
        },
      });
    }else if(this.isRFPorRFQ === 'RFQ'){
      this.router.navigate([`projects/${this.projectId}/rfq/${rfpId}/clarifications`], {
        queryParams: {
          tab: tab,
        },
      });
    }
  }
}
